
































































































































































import { Component, Vue } from "vue-property-decorator";
import CommonLogin from "./common.vue";

@Component({
  extends: CommonLogin,
})
export default class LoginNew extends Vue {
  private get formModel(): any {
    return (this as any).loginInfo || {};
  }

  private get keyList(): string[] {
    return Object.keys(this.formModel);
  }

  private get usernameKey(): string {
    return this.keyList[0] || "";
  }

  private get passwordKey(): string {
    return this.keyList[1] || "";
  }

  private get username(): string {
    return this.usernameKey ? this.formModel[this.usernameKey] : "";
  }

  private set username(value: string) {
    if (this.usernameKey) {
      this.formModel[this.usernameKey] = value;
    }
  }

  private get password(): string {
    return this.passwordKey ? this.formModel[this.passwordKey] : "";
  }

  private set password(value: string) {
    if (this.passwordKey) {
      this.formModel[this.passwordKey] = value;
    }
  }
}
